module.exports = __webpack_public_path__ + "static/media/Cross bite14.64555e2a.png";